import { BACKEND_URL } from "./serverUtils";
import axios from "axios";

const headers = {
    "Content-Type": "application/json",
};

export const makeLegalSummarizeRequest = async (data) => {
    try {
        data.model_type = 'legal'
        const response = await axios.post(
            `${BACKEND_URL}/summarize_from_url`,
            JSON.stringify(data),
            { headers }
        );
        console.log("Response in makeLegalSummarizeRequest:", response)
        return response.data;
    } catch (error) {
        console.error("Error in makeLegalSummarizeRequest:", error);
        throw error;
    }
};

export const makeSummarizeRequest = async (data) => {
    try {
        const response = await axios.post(
            `${BACKEND_URL}/summarize_from_url`,
            JSON.stringify(data),
            { headers }
        );
        console.log("Response in makeSummarizeRequest:", response)
        return response.data;
    } catch (error) {
        console.error("Error in makeSummarizeRequest:", error);
        throw error;
    }
};

export const makeSummarizePDFsRequest = async (isFirstTime = true) => {
    try {
        const data = { model_type: 'default' }
        // data.reprocess = isFirstTime
        data.reprocess = false
        const response = await axios.post(
            `${BACKEND_URL}/summarize_from_drive`,
            JSON.stringify(data),
            { headers }
        );
        console.log("Response in makeSummarizePDFsRequest:", response)
        return response.data;
    } catch (error) {
        console.error("Error in makeSummarizePDFsRequest:", error);
        throw error;
    }
};

export const makeLegalSummarizePDFsRequest = async (isFirstTime = true) => {
    try {
        const data = { model_type: 'legal' }
         // data.reprocess = isFirstTime
         data.reprocess = false
        const response = await axios.post(
            `${BACKEND_URL}/summarize_from_drive`,
            JSON.stringify(data),
            { headers }
        );
        console.log("Response in makeSummarizePDFsRequest:", response)
        return response.data;
    } catch (error) {
        console.error("Error in makeSummarizePDFsRequest:", error);
        throw error;
    }
};

export const uploadSummarizePDF = async (file, modelType) => {
    try {
        const formData = new FormData();
        formData.append('pdfFile', file);
        formData.append('model_type', modelType);
        const response = await axios.post(`${BACKEND_URL}/uploadSummarizePDF`, formData)
        //   .then(response => console.log(response))
        //   .catch(error => console.error(error));
        return response.data;
    } catch (error) {
        console.error("Error in uploadSummarizePDF:", error);
        throw error;
    }
};